import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Users } from "lucide-react";
import { api } from "@/lib/api";
import { BookCard, EmptyState, FollowButton } from "@/components/cards";

export default function AuthorDetail() {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  useEffect(() => { api.get(`/authors/${slug}`).then((r) => setA(r.data)).catch(() => setA(false)); }, [slug]);
  if (a === false) return <div className="py-24 text-center text-muted-foreground">Author not found.</div>;
  if (!a) return <div className="py-24 text-center text-muted-foreground">Loading…</div>;
  return (
    <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-12 fade-in">
      <div className="flex flex-col md:flex-row gap-8 items-start">
        <div className="h-32 w-32 rounded-full overflow-hidden border-2 border-primary/40 bg-secondary shrink-0">
          {a.avatar ? <img src={a.avatar} alt={a.name} className="h-full w-full object-cover" /> : <div className="h-full w-full grid place-items-center text-4xl font-display">{a.name[0]}</div>}
        </div>
        <div>
          <h1 className="text-4xl md:text-5xl font-display font-bold">{a.name}</h1>
          {a.pen_name && <p className="text-primary mt-1">writing as {a.pen_name}</p>}
          <p className="text-muted-foreground mt-4 max-w-2xl">{a.bio}</p>
          <div className="flex items-center gap-4 mt-4">
            <FollowButton author={a} />
          </div>
        </div>
      </div>

      {a.series?.length > 0 && (
        <section className="mt-12">
          <h2 className="text-2xl font-display font-bold mb-4">Series</h2>
          <div className="flex flex-wrap gap-3">
            {a.series.map((s) => (
              <Link key={s.id} to={`/series/${s.slug}`} className="px-4 py-2 rounded-full border border-border hover:border-primary transition-colors text-sm">{s.name}</Link>
            ))}
          </div>
        </section>
      )}

      <section className="mt-12">
        <h2 className="text-2xl font-display font-bold mb-6">Books</h2>
        {a.books?.length ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {a.books.map((b) => <BookCard key={b.id} book={b} />)}
          </div>
        ) : <EmptyState title="No published books yet" />}
      </section>
    </div>
  );
}
